var _defs, _circle, _circle2, _circle3, _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPart139Badge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    role: "img",
    "aria-label": "14 CFR Part 139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p139Ring",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0A4F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#063A6B"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 76,
    fill: "url(#p139Ring)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 68,
    fill: "none",
    stroke: "#F5C518",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 60,
    fill: "#FFFFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 58)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -38,
    y: 8,
    width: 76,
    height: 14,
    rx: 2,
    fill: "#0A4F8C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: 13,
    width: 10,
    height: 4,
    fill: "#F5C518"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: 13,
    width: 10,
    height: 4,
    fill: "#F5C518"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13,
    width: 10,
    height: 4,
    fill: "#F5C518"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 13,
    width: 6,
    height: 4,
    fill: "#F5C518"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -22,
    width: 12,
    height: 30,
    fill: "#0A4F8C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -14,
    y: -28,
    width: 28,
    height: 10,
    rx: 1,
    fill: "#065B70"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -26,
    width: 6,
    height: 5,
    fill: "#35D7E4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: -26,
    width: 6,
    height: 5,
    fill: "#35D7E4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -34,
    width: 2,
    height: 6,
    fill: "#0A4F8C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -36,
    r: 2.5,
    fill: "#F5C518"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 108,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 0.5,
    fill: "#0A4F8C"
  }, "PART 139")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 122,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 600,
    letterSpacing: 1,
    fill: "#065B70"
  }, "AIRPORTS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPart139Badge);
export default __webpack_public_path__ + "static/media/Part139_Badge.1873383b1219602c886de0c6f0cfffb3.svg";
export { ForwardRef as ReactComponent };